<template>
  <O3D><slot></slot></O3D>
</template>

<script>
// import { WoozyMaterial } from '../../Reusable/WoozyMaterial'
import { O3DG2 } from '../../Reusable/O3DG2'
import { ShaderCube } from '../../Reusable/ShaderCube'
import { loadFBX } from '../../Reusable/loadFBX'
import { Color, TextureLoader, MeshMatcapMaterial, DoubleSide, MeshBasicMaterial } from 'three'

export default {
  mixins: [O3DG2],
  props: {
    envMap: {},
    opacity: {
      default: 1
    },
  },

  watch: {
    opacity (v) {
      this.setOpacity(v)
    }
  },
  methods: {
    setOpacity (v) {
      this.o3d.traverse(async (item) => {
        if (item.isMesh) {
          item.material.transparent = true
          item.material.opacity = v
        }
      })
    },
    setup () {
      let url = require('file-loader!./fbx/factory-simple-fbx.fbx')
      let silverTextureURL = require('./matcap/silver.png')
      let textureLaoder = new TextureLoader()
      let silverTexture = textureLaoder.load(silverTextureURL)
      if (!this.envMap) {
        this.shaderCube = new ShaderCube({ renderer: this.ctx.renderer, loop: this.onLoop, res: 12, color: new Color('#ffffff') })
      }

      // let woozy = new WoozyMaterial()
      // woozy.tCube = this.shaderCube.out.envMap

      loadFBX(url).then((fbx) => {
        fbx.traverse((item) => {
          if (item.isMesh) {
            // console.log(item.name)
            if (this.envMap) {
              item.material = new MeshBasicMaterial({ envMap: this.envMap })
            } else {
              item.material =  this.shaderCube.out.material
            }

            if (item.name === 'Plane' || item.name === 'Cube' || item.name === 'Mesh017') {
              item.material = new MeshMatcapMaterial({ matcap: silverTexture, side: DoubleSide })
            }
            item.material.side = DoubleSide
            item.material.flatShading = true
          }
        })

        let scale = 1.0
        // this.o3d.position.y = 242.6 * scale
        fbx.scale.x = scale
        fbx.scale.y = scale
        fbx.scale.z = scale
        this.o3d.add(fbx)
        this.setOpacity(this.opacity)
      })
    }
  },
  mounted () {
    this.setup()
  }
}

/*

Vision 5 Years and 1 Year
Weekly plan 1 3 5 release different content, 2 4 6 release different work
Income within 1year 5 years
Authoratative experiece in the structruing the code base in Front end, Threejs and Vuejs

*/
</script>

<style>

</style>
